import {
    MUNICIPI_OBTENIR_EN_CURS,
    MUNICIPI_OBTENIR_FINALITZADA
} from '../../actions/actionTypes';

const ESTAT_INICIAL = false;

const peticioObtenirMunicipisEnCurs = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case MUNICIPI_OBTENIR_EN_CURS:
            return true;
        case MUNICIPI_OBTENIR_FINALITZADA:
            return false;
        default:
            return state;
    }
};

export default peticioObtenirMunicipisEnCurs;



// WEBPACK FOOTER //
// ./src/reducers/municipis/peticioObtenirMunicipisEnCurs.js